import * as React from 'react'

import { Plus, XIcon } from 'lucide-react'
import { inject, observer } from 'mobx-react'

import { Button } from '~/client/src/shared/components/Button/Button'
import {
  Drawer,
  DrawerContent,
  DrawerFooter,
  DrawerTitle,
} from '~/client/src/shared/components/shadcn-ui/drawer'
import { canCreateWorkflowAt } from '~/client/src/shared/components/SitemapCards/LocationCard'
import LocationCardBody from '~/client/src/shared/components/SitemapCards/LocationCardBody'
import MapViewItemBase from '~/client/src/shared/components/SitemapHelpers/models/MapViewItemBase'
import Localization from '~/client/src/shared/localization/LocalizationManager'
import InitialState from '~/client/src/shared/stores/InitialState'

interface IProps {
  isOpen: boolean
  item: MapViewItemBase
  onCreateWorkflow: () => void
  onClose: () => void
  selectedStartDate?: Date
  selectedEndDate?: Date
  state?: InitialState
}

// The mobile location card: a labelled "Create workflow" where desktop has a bare "+", which on
// a phone sits beside the app's own "+".
// noBodyStyles: vaul's fixed <body> collapses the map's AutoSizer under the sheet (STX1-443).
const LocationDrawer: React.FC<IProps> = ({
  isOpen,
  item,
  onCreateWorkflow,
  onClose,
  selectedStartDate,
  selectedEndDate,
  state,
}) => {
  // The last location, kept through the close so a sliding sheet does not empty mid-slide.
  const lastItem = React.useRef(item)
  if (item) lastItem.current = item
  const shown = item ?? lastItem.current

  return (
    <Drawer
      open={isOpen}
      onOpenChange={open => !open && onClose()}
      noBodyStyles
    >
      <DrawerContent aria-describedby={undefined}>
        <DrawerTitle className="tw:sr-only">
          {shown?.dataObject?.name}
        </DrawerTitle>
        <div className="tw:flex tw:items-start tw:gap-2 tw:px-4 tw:pt-2 tw:pb-1">
          {shown && (
            <LocationCardBody
              item={shown}
              selectedStartDate={selectedStartDate}
              selectedEndDate={selectedEndDate}
            />
          )}
          <Button
            variant="ghost"
            size="icon-lg"
            className="tw:-mt-2 tw:-mr-3 tw:size-11 tw:shrink-0"
            onClick={onClose}
            aria-label={Localization.translator.close}
          >
            <XIcon aria-hidden="true" />
          </Button>
        </div>
        {shown?.dataObject && canCreateWorkflowAt(shown, state) && (
          <DrawerFooter>
            <Button
              size="lg"
              className="tw:h-11 tw:w-full"
              onClick={onCreateWorkflow}
            >
              <Plus aria-hidden="true" />
              {Localization.translator.createWorkflow}
            </Button>
          </DrawerFooter>
        )}
      </DrawerContent>
    </Drawer>
  )
}

export default inject('state')(observer(LocationDrawer))
